import React, { useState, useEffect } from 'react';
import TokenTable from './TokenTable';
import { getTokens, clearTokens } from '../../flux/actions/tokenActions';
import { Container, Row, Col, Button } from 'reactstrap';

import { connect } from 'react-redux';
import { TokenContainer, ITokenReduxProps } from '../../types/interfaces';
import LoadingPage from '../../pages/loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faBoxOpen, faUsers, faDesktop } from '@fortawesome/free-solid-svg-icons'
import Durations from '../Durations';
import { constants } from '../../types/constants';

const TokenContainerComponent = ({
  getTokens,
  clearTokens,
  token,
 }: TokenContainer) => {

  const { tokens, loading } = token;
  const [tableData, setTableData] = useState(tokens);
  const [selectedDuration, setSelectedDuration] = useState(constants.DURATIONS._7_DAYS);
  
  useEffect(() => {
    getTokens(selectedDuration);
  }, [getTokens, selectedDuration]);

  useEffect(() => {
    return () => {
      clearTokens();
    }
  }, []);

  useEffect(() => {
    setTableData(tokens);
  }, [tokens]);

  return loading ? <LoadingPage/> : (
    <>
      <Container>
        <Row className="justify-content-between">
          <Col xs="12" md="12"><h2 className="title"><FontAwesomeIcon icon={faDesktop} />&nbsp;&nbsp;Parc Informatique</h2></Col>
        </Row>
      </Container>
      <Durations selectedDuration={selectedDuration} setSelectedDuration={setSelectedDuration} style={{marginTop: "6px"}} />
      <TokenTable tokensData={tableData} />
    </>
  );
};

const mapStateToProps = (state: ITokenReduxProps) => ({
  token: state.token,
  isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps, { getTokens, clearTokens })(TokenContainerComponent);
